<template>
    <div class="modal-goodslist">
        <div class="modal">
            <div class="modal-header">
                <div style="padding: 6px;">添加治疗处方</div>
                <button type="button" class="btn-close" @click="closeSelf">关闭</button>
            </div>
            <div class="modal-body">

                <el-form :model="addForm" ref="addForm" :rules="rules">
                    <div>
                        <el-row>
                            <el-col :span="12" class="item">
                                <el-form-item label="治疗组名称" required prop='name'>
                                    <el-input v-model="addForm.name" placeholder="请输入治疗组名称"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12" class="item">
                                <el-form-item label="治疗项目" required prop='treatmentItemCodeArr'>
                                    <el-select
                                        v-model="addForm.treatmentItemCodeArr"
                                        style="width:100%"
                                        multiple
                                        filterable
                                        placeholder="请选择治疗项目">
                                        <el-option
                                            v-for="item in treatmentItemList"
                                            :key="item.treatmentItemCode"
                                            :label="item.name"
                                            :value="item.treatmentItemCode">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="24" class="item">
                                <el-form-item label="治疗组内容" required prop='content'>
                                    <el-input v-model="addForm.content" type="textarea"  rows="3" placeholder="请输入治疗组内容"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>

                </el-form>

            </div>
            <div class="modal-footer">
                <el-button :loading="loading" type="primary" @click="confirm('addForm')">添加</el-button>
            </div>
        </div>
    </div>
</template>

<script>

    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import {getStaffCode} from "@/utils/auth";


    export default {
        name: 'Add',
        props:['treatmentItemList'],
        data() {
            return {

                loading: false,

                addForm:{
                    timeStr:timeStr,
                    sign:'',
                    staffCode:getStaffCode(),
                    consultationRecordCode:'',
                    content:'',
                    name:'',
                    treatmentItemCodeArr:[]
                },
                rules:{
                    content:[
                        { required: true, message: '请输入治疗组内容', trigger: 'blur' },
                    ],
                    treatmentItemCodeArr:[
                        { required: true, message: '请选择治疗项目', trigger: 'blur' },
                    ],
                    name:[
                        { required: true, message: '请输入治疗组名称', trigger: 'blur' },
                    ],
                }
            }
        },

        methods: {
            init(code){
                this.loading=false
                this.$refs.addForm.resetFields();
                this.addForm.consultationRecordCode=code
            },
            closeSelf() {
                this.$emit("closeAddTreat");
            },
            
            confirm(addForm){
                this.$refs[addForm].validate((valid) => {
                    if(valid){
                        this.addSubmit();
                    }else {
                        console.log('error submit!!');
                        return false;
                    }
                })
            },

            addSubmit(){

                if(this.loading){
                    return;
                }else{
                    this.loading = true;
                }

                this.addForm.sign = hex_md5("timeStr=" + timeStr + "&key="+this.$signKey);
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"CureFlow/AddPrescriptionTreatment",
                    data: this.addForm
                }).then(
                    (response) => {
                        this.loading = false;
                        if (response.data.error == 0) {
                            this.$emit("closeAddTreat");
                            this.$emit("getList");
                        }else if(response.data.error == 1){
                            this.$message({type: 'info', message: response.data.message});
                        }
                    }
                )
            },


        }
    }


</script>





<style lang="scss" scoped>

    .modal-goodslist {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: rgba(0,0,0,.3);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 99;

        .modal {
            background-color: #fff;
            box-shadow:  0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
            overflow-x:auto;
            display: flex;
            flex-direction: column;
            border-radius: 10px;
            width: 600px;

            .modal-header {
                border-bottom: 1px solid #eee;
                color: #313131;
                justify-content: space-between;
                padding: 10px;
                display: flex;
            }
            .modal-body {
                position: relative;
                padding: 20px 0px;
                z-index: 99;
                height: 100%;
            }
            .modal-footer {
                border-top: 1px solid #eee;
                justify-content: flex-end;
                padding: 15px;
                display: flex;
            }


        }

    }


    .btn-close, .btn-confirm {
        border-radius: 8px;
        margin-left:16px;
        width:56px;
        height: 36px;
        border:none;
        cursor: pointer;
    }
    .btn-close {
        color: #313131;
        background-color:transparent;
    }



    .row{
        padding: 10px 0px;
    }
    .item{
        padding: 0px 20px;
    }
    .label{
        padding: 5px 0px;
    }


</style>
